module.exports = "https://static.wmbcdn.com/uniweb/images/f3dc88508df985aacb5fa10f657f8ba5.svg";